import React, { Component } from 'react';
import { Form, FormGroup } from '@Comp';
import { inject, observer } from 'mobx-react';
import validate from 'validate.js';
import { businessAddressSchema } from '../ValidationSchemas';

@inject('businessProfileStore')
@observer
class BusinessDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',
            fetchClick: false,
            wordCount: 0,
            exceedsLimit: false
        };
        this.formState = {
            isValid: false,
            values: {},
            touched: {},
            errors: {}
        };
    }

    componentDidMount() {
        const { companyDetails } = this.props.businessProfileStore.businessProfile;
        if (companyDetails && companyDetails.businessAddress) {
            const description = companyDetails.businessAddress.description || '';
            const wordCount = this.countWords(description);
            this.setState({
                description: description,
                wordCount: wordCount,
                exceedsLimit: wordCount > 250
            });
        }
    }

    componentDidUpdate() {
        if (this.props.fetchClick && !this.state.fetchClick) {
            const { companyDetails } = this.props.businessProfileStore.businessProfile;
            if (companyDetails && companyDetails.businessAddress) {
                const description = companyDetails.businessAddress.description || '';
                const wordCount = this.countWords(description);
                this.setState({
                    description: description,
                    wordCount: wordCount,
                    exceedsLimit: wordCount > 250,
                    fetchClick: true
                });
            }
        }
    }

    countWords = (text) => {
        if (!text || text.trim().length === 0) return 0;
        return text.trim().split(/\s+/).length;
    };

    handleChange = e => {
        const { value } = e.target;
        const wordCount = this.countWords(value);
        const exceedsLimit = wordCount > 250;

        this.setState({
            description: value,
            wordCount: wordCount,
            exceedsLimit: exceedsLimit
        }, () => {
            // Update the store with the new description
            const { businessProfileStore } = this.props;

            // Initialize businessAddress if it's not an object
            if (!businessProfileStore.businessAddress || typeof businessProfileStore.businessAddress !== 'object') {
                businessProfileStore.businessAddress = {
                    unitNo: '',
                    streetName: '',
                    suburb: '',
                    city: '',
                    province: '',
                    postalCode: '',
                    description: '',
                    areaCategory: null,
                    proofOfAddress: [],
                    companyDetails: null
                };
            }

            // Copy existing values from businessProfile if they exist
            if (businessProfileStore.businessProfile.companyDetails &&
                businessProfileStore.businessProfile.companyDetails.businessAddress) {
                const existingAddress = businessProfileStore.businessProfile.companyDetails.businessAddress;
                businessProfileStore.businessAddress = {
                    ...existingAddress,
                    description: value
                };
            } else {
                businessProfileStore.businessAddress.description = value;
            }

            businessProfileStore.fieldsToUpdate.businessAddressDirty = true;

            // Enable save button by calling formDataChange from parent
            if (this.props.formDataChange) {
                this.props.formDataChange(
                    businessProfileStore.businessAddress,
                    'description'
                );
            }
        });
    };

    render() {
        const { businessProfile } = this.props.businessProfileStore;

        return (
            <div className="row">
                <Form className="col-12" id="businessDescription" name="businessDescription">
                    <FormGroup>
                        <p style={{ marginBottom: '10px', color: '#666' }}>
                            Please give us a short description of your company focusing on its main operations, clients, number of employees and any other relevant information that you would like to be part of your business profile.
                        </p>
                        <textarea
                            id="description"
                            name="description"
                            rows={3}
                            className="form-control"
                            placeholder="Write description"
                            value={this.state.description}
                            onChange={this.handleChange}
                            disabled={!businessProfile.isEditable}
                            style={{
                                width: '100%',
                                resize: 'vertical',
                                border: this.state.exceedsLimit ? '1px solid #dc3545' : '1px solid #ccc',
                                padding: '10px',
                                fontSize: '14px',
                                borderRadius: '4px'
                            }}
                        />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '5px',
                            fontSize: '12px'
                        }}>
                            <span style={{ color: this.state.exceedsLimit ? '#dc3545' : '#666' }}>
                                {this.state.wordCount} / 250 words
                                {this.state.exceedsLimit && ' (Exceeds limit!)'}
                            </span>
                            <span style={{ color: '#999' }}>MAX 250 words</span>
                        </div>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default BusinessDescription;
